import React from 'react';
import { Category } from '../../types';

interface MenuFiltersProps {
  categories: Category[];
  activeCategory: string;
  searchQuery: string;
  onCategoryChange: (categoryId: string) => void;
  onSearchChange: (query: string) => void;
  themeColor?: string;
}

const MenuFilters: React.FC<MenuFiltersProps> = ({
  categories,
  activeCategory,
  searchQuery,
  onCategoryChange,
  onSearchChange,
  themeColor = '#000'
}) => {
  return (
    <div className="d-none d-md-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-3 mb-2 pb-3 pt-4 filter-search-container">
      <select 
        className="form-select border-0 shadow-sm fw-bold rounded-3 px-3 py-2 fs-6" 
        style={{ width: 'auto', minWidth: '240px' }}
        value={activeCategory || ''}
        onChange={(e) => onCategoryChange(e.target.value)}
      >
        <option value="">Lista de categorias</option>
        {categories.map(category => (
          <option key={category.id} value={category.id}>{category.name}</option>
        ))}
      </select>

      <div className="position-relative flex-grow-1" style={{ maxWidth: '400px' }}>
        <i className="fas fa-search position-absolute text-muted" style={{ left: '1.2rem', top: '50%', transform: 'translateY(-50%)', zIndex: 1 }} />
        <input 
          type="text" 
          className="form-control border-0 shadow-sm rounded-3 py-2 fw-medium" 
          style={{ paddingLeft: '3rem', paddingRight: '2.5rem' }}
          placeholder="Busque por um produto" 
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {searchQuery && (
          <button 
            onClick={() => onSearchChange('')}
            className="btn btn-link position-absolute p-0 text-muted border-0"
            style={{ right: '1rem', top: '50%', transform: 'translateY(-50%)', zIndex: 2 }}
          >
            <i className="fas fa-times" />
          </button>
        )}
      </div>
    </div>
  );
};

export default MenuFilters;
